import React from 'react'

const ErrorPage = () => {
  return (
    <div className='md:pt-[450px]'>Error! Page not found!</div>
  )
}

export default ErrorPage